import { DataFileStatus } from 'common/src/types/enums/DataFileStatus.enum';

type StatusColor = 'default' | 'info' | 'success' | 'error' | 'warning';

export const getFileStatusChipColor = (status: DataFileStatus): StatusColor => {
  let color: StatusColor;

  switch (status) {
    case DataFileStatus.Processed:
    case DataFileStatus.Parsed:
      color = 'success';
      break;
    case DataFileStatus.Abandoned:
    case DataFileStatus.Error:
      color = 'error';
      break;
    case DataFileStatus.Split:
      color = 'info';
      break;
    case DataFileStatus.ClientReviewRequired:
    case DataFileStatus.ManualProcessingRequired:
      color = 'warning';
      break;
    case DataFileStatus.Pending:
    case DataFileStatus.InParsing:
    case DataFileStatus.InProcessing:
    default:
      color = 'default';
  }

  return color;
};
